// extracted by mini-css-extract-plugin
export var progressBar = "_n5-0";
export var progressBarInner = "_n5-1";